export default __webpack_public_path__ + "static/media/ser5.ea690243.svg";